import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { useSettings } from "../lib/settings";
import { T } from "../lib/autoTranslate";

const TermsPage = () => {
  const { settings } = useSettings();
  const s = settings || {};
  const sections = s.terms_sections || [];

  return (
    <div className="pt-16">
      <SEO
        title="Terms & Conditions · Free Istanbul Tours"
        description="Booking terms, cancellation policy, and conditions for tours with Free Istanbul Tours."
        path="/terms-conditions"
      />
      <section className="section-tight bg-[var(--ri-cream)]">
        <div className="container-x max-w-[760px]">
          <p className="eyebrow mb-3"><T>Legal</T></p>
          <h1 className="font-serif-display text-[32px] md:text-[42px] leading-[1.08]"><T>Terms & Conditions</T></h1>
          <p className="mt-4 text-[14px] text-[var(--ri-muted)]">
            <T>Last updated:</T> {s.terms_updated || "August 2026"}
          </p>

          {sections.map((sec, i) => (
            <div key={i} className="mt-8">
              {sec.title && <h2 className="font-serif-display text-[22px] md:text-[24px] mb-3"><T>{sec.title}</T></h2>}
              <div className="space-y-1.5 text-[15px] leading-[1.75] text-[var(--ri-ink-soft)]">
                {(sec.text || "").split("\n").filter((line) => line.trim() !== "").map((line, j) => (
                  <p key={j}><T>{line}</T></p>
                ))}
              </div>
            </div>
          ))}

          <div className="mt-8">
            <h2 className="font-serif-display text-[22px] md:text-[24px] mb-3"><T>Contact us</T></h2>
            <p className="text-[15px] leading-[1.75] text-[var(--ri-ink-soft)]">
              <T>Questions about these terms, or about an existing booking, can be sent through our</T>{" "}
              <Link to="/contact" className="text-[var(--ri-red)] link-underline">
                <T>contact page</T>
              </Link>
              .
            </p>
          </div>

          <p className="mt-10 text-[12.5px] text-[var(--ri-muted)] italic">
            <T>This page is provided as a general template and does not constitute legal advice. We recommend having it
            reviewed by a qualified professional to ensure it meets applicable legal requirements for your business.</T>
          </p>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
